<script>
    import { flip } from 'svelte/animate';
    import { quintOut } from 'svelte/easing';
    import { fade } from 'svelte/transition';
    import { API_URL } from "./Var.svelte"


    let searchText = "";

    let searchResult = [];
    const api_host = API_URL;

    let show = false;


    async function fetchData(searchText) {
    let url = `${api_host}/search?q=${searchText}`;
        const response = await fetch(url);
        searchResult = await response.json();
    }

    $: fetchData(searchText)

    async function handleSongClicked (uri) {
        let url = `${api_host}/?addSong=${uri}`;
        const response = await fetch(url);
        searchText = "";
        show = true;
        setInterval(() => show = false, 2000);
    }

</script>

<div class="main">
    <h4>Add a song to the vote!</h4>
    <input type="text" bind:value={searchText}>
    {#if show}
    <div class="popup" transition:fade={{ delay: 0, duration: 200 }}><span>Added Song!</span></div>
    {/if}
    {#if searchText}
    <div class="songs">
        {#each searchResult as song (song.uri)}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="song" animate:flip={{ delay: 250, duration: 500, easing: quintOut }} on:click={() => handleSongClicked(song.uri)}>
        <img src={song.album.images[0].url} alt="Album {song.album.name}">
        <span>{song.name}<br>{song.artists[0].name}</span>
    </div>
        {/each}
    </div>
        {/if}
</div>

<style>
    .main {
        padding: 30px;
        box-sizing: border-box;
        padding-bottom: 0;
    }

    input {
        width: 100%;
    }

    .songs {
        display: flex;
        flex-direction: column;
        margin: auto;
        width: 100%;
        box-sizing: border-box;
        padding: 30px;
    }

    .song {
        height: 60px;
        background-color: #191414;
        color: aliceblue;
        margin: 10px;
        display: flex;
        align-items: center;
        border-radius: 5px;
        box-shadow: 3px 3px 10px #888888;
        overflow: hidden;
    }

    .song span {
        margin-left: 1em;
    }

    .song img {
        height: 100%;
    }

    .popup {
        background-color: #1Db954;
        color: aliceblue;
        padding: 0.5em;
        box-sizing: border-box;
        border-radius: 5px;
        text-align: center;
        width: 100%;
        margin:auto;
    }

</style>